import { Controller } from "@hotwired/stimulus";

// Toggles all row checkboxes inside a single group. Reads/writes its own
// "all selected" state from the rows so it stays in sync when users tick
// individual rows. After toggling, dispatches `change` on each row so the
// outer `checkbox-select-all` controller updates its bulk bar.
export default class extends Controller {
  static targets = ["selectAll", "checkbox"];

  connect() {
    this.refresh();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => {
      if (cb.checked === checked) return;
      cb.checked = checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  refresh() {
    if (!this.hasSelectAllTarget) return;
    const total = this.checkboxTargets.length;
    if (total === 0) {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = false;
      return;
    }
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length;
    this.selectAllTarget.checked = checked === total;
    this.selectAllTarget.indeterminate = checked > 0 && checked < total;
  }
}
